import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { Box, SmallSection } from '../../../components/design';
import { getCurrencyById } from '../../../library/helpers/currency';
import { formatDate, formatDateTime, formatPrice } from '../../../library/utils';
import styles from './logs.module.scss';
const { Panel } = Collapse;

const Price = ({ price, currency }) => {
    if (!price) {
        return 'NA'
    }
    return (
        <>
            <div>{formatPrice(price, currency)}</div>
        </>
    )
}
Price.propTypes = {
    price: PropTypes.number,
    currency: PropTypes.oneOf(['EUR', 'GBP', 'USD']).isRequired,
}
const statusName = (status) => {
    const statuses = {
        1: 'Active',
        2: 'Send',
        3: "Visual Request",
        4: "Response from Leopriting",
        5: 'Cancelled',
        6: "Approved"
    }
    return statuses[status]
}
const getStatus = (status) => {
    return status == 1 ? <div className={styles.active}>{statusName(status)}</div> : <div className={styles.inactive}>{statusName(status)}</div>
}
const CombiQuotationLogs = ({ logs, active }) => {
    return <Collapse  expandIconPosition="end" defaultActiveKey={"1"}>
        <Panel header='Quotation Logs' key="1">
            <div className={styles.activityLogs}>
                <h3>Active Quotation</h3>
                {active?.item_vendor_quotation_prices && active?.item_vendor_quotation_prices.map((qData) => {
                    return <div key={qData.id}>
                        <div>
                            {/* <p className='smallText'>Created At : {logs == null ? '' : qData.createdAt}</p>
                                <p className='smallText'>Current status : {logs == null ? '' : statusName(qData.status)}</p> */}

                            <div>
                                <Box type={Box.BoxTypes.GRAY} header={
                                    <div className={styles.formGrid}>
                                        <h4>Quantity</h4>
                                        <h4>Artowrk Approval Date</h4>
                                        <h4>Purchase Price</h4>
                                        <h4>Shipping Price</h4>
                                        <h4>Current Status</h4>
                                    </div>

                                } footer={
                                    <div>
                                        <p>Comment : {active?.comment}</p>
                                        <p>Created at : {formatDateTime(qData.createdAt)}</p>
                                    </div>
                                } >
                                    <SmallSection colorLight={'#F1F1F1'} colorDark={'#BABABA'} >
                                        <div className={styles.gridValues}>
                                            <div>{qData.quantity}</div>
                                            <div>{formatDate(qData.expected_artwork_received_date)}</div>
                                            <div>{<Price price={qData.price_unit} currency={active.currency?.code} />}</div>
                                            <div> <Price price={qData.transport_price} currency={active.currency?.code} /></div>
                                            <div>{getStatus(qData.status)}</div>
                                        </div>
                                    </SmallSection>

                                </Box>
                                <br />
                            </div>


                        </div>
                    </div>
                })}
               {logs.length > 0 && <h3>Quotation History</h3>}
                {logs.map((qData) => {
                    return <div key={qData.id}>
                        <div>
                            {/* <p className='smallText'>Created At : {logs == null ? '' : qData.createdAt}</p>
                                <p className='smallText'>Current status : {logs == null ? '' : statusName(qData.status)}</p> */}

                            <div>
                                <Box type={Box.BoxTypes.GRAY} header={
                                    <div className={styles.formGrid}>
                                        <h4>Quantity</h4>
                                        <h4>Artowrk Approval Date</h4>
                                        <h4>Purchase Price</h4>
                                        <h4>Shipping Price</h4>
                                        <h4>Current Status</h4>
                                        <h4>Comment</h4>
                                    </div>

                                } footer={
                                    <div>
                                        <p>Created at : {formatDateTime(qData.createdAt)}</p>
                                    </div>
                                } >{qData.item_vendor_quotation_prices.map((value) => {
                                    return (<SmallSection colorLight={'#F1F1F1'} colorDark={'#BABABA'} key={value?.id}>
                                        <div className={styles.gridValues}>
                                            <div>{value.quantity}</div>
                                            <div>{formatDate(value.expected_artwork_received_date)}</div>
                                            <div>{<Price price={value.price_unit} currency={getCurrencyById(qData.currency_id)?.code} />}</div>
                                            <div> <Price price={value.transport_price} currency={getCurrencyById(qData.currency_id)?.code} /></div>
                                            <div>{getStatus(qData.status)}</div>
                                            <div>{qData?.comment}</div>
                                        </div>
                                    </SmallSection>)
                                })}
                                </Box>
                                <br />
                            </div>


                        </div>
                    </div>
                })}

            </div>
        </Panel>
    </Collapse>
}
CombiQuotationLogs.propTypes = {
    logs: PropTypes.arrayOf(PropTypes.object).isRequired,
    active: PropTypes.arrayOf(PropTypes.object).isRequired,
    statusData: PropTypes.arrayOf(PropTypes.object).isRequired
}
export default CombiQuotationLogs